import ko from './ko.json'
import en from './en.json'
import ch from './ch.json'

const messages = {
    ko, en, ch
}

export default messages




// WEBPACK FOOTER //
// ./src/locales/index.js